import React, {Fragment, ReactElement, useState} from 'react';

import cs from 'classnames';
import {useSelector} from 'react-redux';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

import {DataSharingEnabledGate} from './DataSharingEnabledGate';
import {
  HideDataGatheringButton,
  PermitDataGatheringInfoModal,
} from './PermitDataGatheringInfoModal';
import {EditTextWithOpenAIModal} from './TextEdition/EditTextWithOpenAIModal';

import {selectIsHidingDataAccessInfoBox} from '../slice';

import type {ChatTextEdtionContext} from '../types';
import type {ProcedureVersionSerializedType} from 'sweet-types';

type Props = {
  text: string | null | undefined;
  title: string;
  onConfirmText: (newText: string | ReactElement) => void;
  document: ProcedureVersionSerializedType;
  context?: ChatTextEdtionContext;
};
export const ClickToChatButton = ({
  text,
  title,
  onConfirmText,
  document,
  context,
}: Props) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const isHidingDataAccessInfoBox = useSelector(
    selectIsHidingDataAccessInfoBox
  );

  const startChat = (e) => {
    e.stopPropagation();
    setIsEditModalOpen(true);
  };

  return (
    <div>
      <DataSharingEnabledGate
        sharingEnabledElement={
          <EditTextWithOpenAIModal
            text={text}
            title={title}
            isOpen={isEditModalOpen}
            toggleModal={() => setIsEditModalOpen(false)}
            onConfirmText={onConfirmText}
            document={document}
            context={context}
          />
        }
        sharingDisabledElement={
          <PermitDataGatheringInfoModal
            isOpen={isEditModalOpen}
            toggleModal={() => setIsEditModalOpen(false)}
          />
        }
      />

      <DataSharingEnabledGate
        sharingEnabledElement={
          <LazyTooltip
            tooltip={gt(
              'Team up with SweetAI to edit the contents of this step.'
            )}
          >
            <button
              data-testid="click-to-edit-button"
              className="btn btn-link text-muted ml-1 p-0"
              onClick={startChat}
            >
              <i className={cs('fa fa fa-robot')} />{' '}
              {gt('Edit this step with SweetAI')}
            </button>
          </LazyTooltip>
        }
        sharingDisabledElement={
          isHidingDataAccessInfoBox ? null : (
            <Fragment>
              <LazyTooltip
                tooltip={gt(
                  'Team up with SweetAI to edit the contents of this step.'
                )}
              >
                <button
                  data-testid="click-to-edit-button"
                  className="btn btn-link text-muted ml-1 p-0"
                  onClick={startChat}
                >
                  <i className={cs('fa fa fa-robot')} />{' '}
                  {gt('Edit this step with SweetAI')}
                </button>
              </LazyTooltip>
              <HideDataGatheringButton className="text-muted" />
            </Fragment>
          )
        }
      />
    </div>
  );
};
